import script from "./WeeklyChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeeklyChart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__